import React from 'react';
import { Skeleton } from '../Skeleton';

const ActivityCardLoader = () => {
  return (
    <div className={`w-100 rounded text-start hsptlActivitesCard`}>
      {/* activitesCardYellow   activitesCardRed  activitesCardGreen  activitesCardBlue */}
      <div className="w-100 hsptlActivitesCardIn">
        <div className="d-flex align-items-center justify-content-between mb-2 cursorPointer">
          <h5 className="text-black fw-semibold fs-4">
            <Skeleton variant="text" width={100} height={25} />
          </h5>
          <span className="fw-normal hspltActivitesStts">
            <Skeleton variant="text" width={50} height={25} />
          </span>
        </div>
        <h2 className="fs-3 text-black fw-medium mb-1 cursorPointer">
          <Skeleton variant="text" width={'95%'} height={25} />
        </h2>
        <h4 className="fs-4 text-black cursorPointer">
          <Skeleton variant="text" width={'90%'} height={25} />
        </h4>
        <div className="d-flex align-items-center justify-content-between mt-1 cursorPointer">
          <h5 className="text-black fw-normal fs-4">
            <Skeleton variant="text" width={90} height={25} />
          </h5>
        </div>
      </div>
    </div>
  );
};

export default ActivityCardLoader;
